<template>
  <div class="flex h-full w-full flex-col bg-n-background">
    <router-view />
  </div>
</template>
